<template>
  <VDropdown
    :distance="6"
    placement="auto-end"
    :shown="showPopup"
    :triggers="[]"
    popperClass="tooltip-patient-waiting"
    @hide="showPopup = false"
  >
    <button
      class="
        hover:tw-bg-gray-100
        tw-flex
        tw-items-center
        tw-px-2
        tw-py-1
        tw-rounded
        tw-w-full
        tw-font-medium
      "
      @click="showPopup = true"
    >
      <span class="tw-truncate tw-mr-2">{{
        appointmentDetail.patient.full_name
      }}</span>
      <span class="tw-shrink-0 tw-ml-auto tw-text-gray-500">{{ appointmentDetail.waiting_time }}</span>
      <img :src="faceIndicator" class="tw-ml-1 tw-w-5 tw-h-5" />
    </button>

    <template #popper>
      <div class="tw-border-blue-500 tw-border-t-4 tw-p-4">
        <p class="tw-text-sm tw-font-semibold tw-text-gray-900">
          {{ appointmentDetail.patient.full_name }}
        </p>
        <p
          class="tw-capitalize tw-text-sm tw-mt-2 tw-text-gray-600 tw-truncate"
        >
          {{ formattedTime }}
        </p>
        <div class="tw-flex tw-items-center tw-justify-between">
          <p class="tw-block tw-text-sm tw-mt-1 tw-text-gray-500 tw-font-sans">
            {{ appointmentDetail.professional.full_name }}
          </p>
          <button @click="openAppointmentModal" class="tw-text-blue-600">Editar</button>
        </div>
        <select
          v-model="selectedStatus"
          :disable="loadingUpdateStatus"
          class="
            tw-pl-2 tw-bg-white
            tw-focus:tw-border-blue-400
            tw-rounded
            tw-border-solid
            tw-h-9
            tw-text-gray-700
            tw-w-full
            tw-border-gray-500
            tw-border
            tw-text-sm
            tw-font-sm
            tw-mt-4
          "
        >
          <option
            v-for="status in appointmentsStatus"
            :key="status.value"
            :value="status.value"
          >
            {{ status.label }}
          </option>
        </select>
        <div>
          <img
            :src="loadingIcon"
            class="tw-mx-auto tw-my-2 tw-w-10"
            v-if="loadingUpdateStatus"
          />
        </div>
      </div>
    </template>
  </VDropdown>
</template>
<script>
import loadingIcon from "images/spinner.svg";
import axios from "axios";
import { format, parseISO,isToday } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
};
import sentimentSatisfiedIcon from "images/icons/sentiment_satisfied.svg";
import sentimentNeutralIcon from "images/icons/sentiment_neutral.svg";
import sentimentDissatisfiedIcon from "images/icons/sentiment_dissatisfied.svg";

export default {
  props: ["appointmentDetail"],
  data() {
    return {
      loadingIcon,
      sentimentSatisfiedIcon,
      sentimentNeutralIcon,
      sentimentDissatisfiedIcon,
      showPopup: false,
      loadingUpdateStatus: false,
      selectedStatus: "patient_waiting",
      appointmentsStatus: [
        { value: "scheduled", label: "Agendada" },
        { value: "confirmed", label: "Confirmada" },
        { value: "patient_waiting", label: "Paciente aguardando" },
        { value: "patient_attendance", label: "Paciente em atendimento" },
        { value: "finished", label: "Finalizada" },
        { value: "missed", label: "Faltou" },
        { value: "canceled_by_the_patient", label: "Cancelada pelo paciente" },
        {
          value: "canceled_by_the_professional",
          label: "Cancelada pelo dentista",
        },
      ],
    };
  },
  methods: {
    formatAppointmentTooltipDay(date){
      const currentDate = format(date, "EEEE dd/MM", { locale: ptBR })
      return isToday(date) ? "Hoje" : currentDate.replace("-feira","")
    },
    openAppointmentModal() {
      document.dispatchEvent(
        new CustomEvent("open-appointment-modal", {
          detail: {
            editUrl: `/appointments/${this.appointmentDetail.appointment.id}/edit`,
          },
        })
      );
      this.showPopup = false;
    },
    updateStatus() {
      this.loadingUpdateStatus = true;
      const data = {
        authenticity_token: $("meta[name=csrf-token]").attr("content"),
        "appointment": {status: this.selectedStatus},
      };

      axios
        .put(
          `/appointments/${this.appointmentDetail.appointment.id}/status`,
          data,
          {
            headers: {
              Accept: "application/json",
            },
          }
        )
        .then(({ data }) => {
          this.showPopup = false;
        })
        .catch((error) => {
          swal({
            title: "Ocorreu um erro ao atualizar a consulta",
            html: "Atualize a página e tente novamente.",
            type: "warning",
            confirmButtonText: "OK",
          });
        })
        .finally(() => {
          this.loadingUpdateStatus = true;
        });
    },
  },
  computed: {
    formattedTime() {
      const startAt = parseISO(this.appointmentDetail.appointment.starts_at);
      const endsAt = parseISO(this.appointmentDetail.appointment.ends_at);
      return `${this.formatAppointmentTooltipDay(startAt)} até ${format(endsAt, "HH:mm")}`;
    },
    faceIndicator(){
      if (this.appointmentDetail.duration_in_minutes <= 10) {
        return this.sentimentSatisfiedIcon
      }

      if (this.appointmentDetail.duration_in_minutes <= 20) {
        return this.sentimentNeutralIcon
      }

      return this.sentimentDissatisfiedIcon
    }
  },
  watch: {
    selectedStatus() {
      this.updateStatus();
    },
  },
};
</script>
